import React from "react";
import { Input, Table } from "reactstrap";
import moment from "moment";

export default function DailySummaryTable(props) {
  const {
    totalAmount,
    totalMWh,
    setTotalAmount,
    setTotalMWh,
    totalFsd,
    setTotalFsd,
    totalPsoadmin,
    setTotalPsoadmin,
    totalEmcadmin,
    setTotalEmcadmin,
    totalNetAmount,
    setTotalNetAmount,
    cceAmount,
    setCceAmount,
    clientAmount,
    setClientAmount,
    dailyRebates,
    setDailyRebates,
    onInputChange,
  } = props;
  function onChangeDailyRebate(e, index, name) {
    const tempDailyRebates = [...dailyRebates];
    tempDailyRebates[index][name] = e.target.value;
    setDailyRebates(tempDailyRebates);
  }

  return (
    <Table bordered>
      <thead>
        <tr>
          <th>Date</th>
          <th>Energy (MWh)</th>
          <th>Amount (SGD)</th>
          <th>FSD (SGD)</th>
          <th>PSO Admin Charge (SGD)</th>
          <th>EMC Admin Charge (SGD)</th>
          <th>Net Amount (SGD)</th>
        </tr>
      </thead>
      <tbody>
        {dailyRebates.map((dailyRebate, index) => {
          return (
            <tr key={index}>
              <th scope="row">
                {moment(dailyRebate.settlementDate).format("DD MMM YYYY")}
              </th>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.totalMWh}
                  onChange={(e) => onChangeDailyRebate(e, index, "totalMWh")}
                  step={0.001}
                />
              </td>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.totalAmount}
                  onChange={(e) => onChangeDailyRebate(e, index, "totalAmount")}
                  step={0.01}
                />
              </td>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.fsd}
                  onChange={(e) => onChangeDailyRebate(e, index, "fsd")}
                  step={0.01}
                />
              </td>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.psoadmin}
                  onChange={(e) => onChangeDailyRebate(e, index, "psoadmin")}
                  step={0.01}
                />
              </td>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.emcadmin}
                  onChange={(e) => onChangeDailyRebate(e, index, "emcadmin")}
                  step={0.01}
                />
              </td>
              <td>
                <Input
                  type="number"
                  value={dailyRebate.netAmount}
                  onChange={(e) => onChangeDailyRebate(e, index, "netAmount")}
                  step={0.01}
                />
              </td>
            </tr>
          );
        })}
        <tr>
          <th scope="row">Total</th>
          <td>
            <Input
              type="number"
              value={totalMWh}
              onChange={(e) => onInputChange(e, setTotalMWh)}
              step={0.001}
            />
          </td>
          <td>
            <Input
              type="number"
              value={totalAmount}
              onChange={(e) => onInputChange(e, setTotalAmount)}
              step={0.01}
            />
          </td>
          <td>
            <Input
              type="number"
              value={totalFsd}
              onChange={(e) => onInputChange(e, setTotalFsd)}
              step={0.01}
            />
          </td>
          <td>
            <Input
              type="number"
              value={totalPsoadmin}
              onChange={(e) => onInputChange(e, setTotalPsoadmin)}
              step={0.0001}
            />
          </td>
          <td>
            <Input
              type="number"
              value={totalEmcadmin}
              onChange={(e) => onInputChange(e, setTotalEmcadmin)}
              step={0.0001}
            />
          </td>
          <td>
            <Input
              type="number"
              value={totalNetAmount}
              onChange={(e) => onInputChange(e, setTotalNetAmount)}
              step={0.01}
            />
          </td>
        </tr>
      </tbody>
    </Table>
  );
}
